import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class RedirectIfAuthenticatedGuard {
  private whoami = inject(WhoAmIService);
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.whoami.isAuthenticated()) {
      // Redirect authenticated users based on their role
      if (this.whoami.isRoot()) {
        this.router.navigate(['/analytics']);
      } else if (this.whoami.isUser()) {
        this.router.navigate(['/orgs', 'active', 'srvs']);
      } else {
        // User without known role (not USER, not root) - redirect to profile
        this.router.navigate(['/me']);
      }
      return false;
    } else {
      return true;
    }
  }
}
